'use client';

import { Button } from '@/components/ui/Button';
import { useTranslations } from 'next-intl';
import { ReactNode, useState } from 'react';

interface ExpandableGridProps {
  children: ReactNode[];
  initialDisplayCount?: number;
  gridClassName?: string;
  seeMoreLabel?: string;
}

export function ExpandableGrid({
  children,
  initialDisplayCount = 6,
  gridClassName = 'mx-auto max-w-[1740px] space-y-8 lg:space-y-18 md:grid md:grid-cols-2 md:gap-x-3 lg:grid-cols-3 lg:gap-x-12',
  seeMoreLabel,
}: ExpandableGridProps) {
  const t = useTranslations('components.ExpandableGrid');
  const [showAll, setShowAll] = useState(false);

  const shouldShowSeeMore = children.length > initialDisplayCount;
  const displayedChildren = showAll
    ? children
    : children.slice(0, initialDisplayCount);

  return (
    <>
      <div className={gridClassName}>{displayedChildren}</div>
      {shouldShowSeeMore && !showAll && (
        <div className='mt-12 flex justify-center'>
          <Button
            variant='light'
            onClick={() => setShowAll(true)}
            aria-label={seeMoreLabel ?? t('seeMoreLabel')}
          >
            {seeMoreLabel ?? t('seeMore')}
          </Button>
        </div>
      )}
    </>
  );
}
